import { GlobalStateContext } from '../GlobalState';
import { useContext } from 'react';
import { fetchData } from '../services';
import { BggUser } from '../objects';

const CACHE_KEY = 'bgg_users_cache';
const CACHE_DURATION = 24 * 60 * 60 * 1000; // 24 hours

const useBggUsers = () => {
    const { bggUsers, setBggUsers } = useContext(GlobalStateContext);

    const loadUserCache = () => {
        try {
            const cached = localStorage.getItem(CACHE_KEY);
            return cached ? JSON.parse(cached) : {};
        } catch (error) {
            console.error('Error loading user cache from localStorage:', error);
            return {};
        }
    };

    const saveUserCache = (cache) => {
        try {
            localStorage.setItem(CACHE_KEY, JSON.stringify(cache));
        } catch (error) {
            console.error('Error saving user cache to localStorage:', error);
        }
    };

    const findBggUser = async (id) => {
        let users = bggUsers;

        // Check memory cache first
        let cachedUser = users.find(user => user.id === id);
        if (cachedUser) {
            return cachedUser;
        }

        // Check browser cache
        const userCache = loadUserCache();
        const cacheEntry = userCache[id];

        if (cacheEntry && (Date.now() - cacheEntry.timestamp) < CACHE_DURATION) {
            // Add to memory cache and return
            users.push(cacheEntry.user);
            setBggUsers(users);
            return cacheEntry.user;
        }

        // Fetch from API if not cached or expired
        const userData = await fetchData(`/api/users/${id}`);
        const user = new BggUser(userData.username, userData.name, id, userData.city, userData.state, [], [], []);
        users.push(user);

        // Store in browser cache with timestamp
        userCache[id] = { user, timestamp: Date.now() };
        saveUserCache(userCache);

        setBggUsers(users);
        return user;
    }

    return {
        findBggUser
    };
};

export default useBggUsers;
